import { render, staticRenderFns } from "./DrawerItem.vue?vue&type=template&id=fea451c8"
import script from "./DrawerItem.vue?vue&type=script&lang=js"
export * from "./DrawerItem.vue?vue&type=script&lang=js"
import style0 from "./DrawerItem.vue?vue&type=style&index=0&id=fea451c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports